/* DRIVE IQ — ADVENTURE CONFIG V606 COFFEE DEFAULT
   Complete replacement of V600.11. Only default category and build label differ.
   No change to inventory limits, maps, routing, providers, resume or features.
*/
(function(window){
"use strict";
if(window.DriveIQAdventureConfig){return;}
function stringValue(value,fallback){
  var text=String(value==null?"":value).trim();
  return text||String(fallback==null?"":fallback);
}
function numberValue(value,fallback,minimum,maximum){
  var parsed=Number(value);
  if(!isFinite(parsed)){parsed=Number(fallback);}
  if(isFinite(Number(minimum))){parsed=Math.max(Number(minimum),parsed);}
  if(isFinite(Number(maximum))){parsed=Math.min(Number(maximum),parsed);}
  return parsed;
}
function booleanValue(value,fallback){
  if(value===true||value===false){return value;}
  if(value==="true"||value==="1"||value===1){return true;}
  if(value==="false"||value==="0"||value===0){return false;}
  return fallback===true;
}
var runtime=window.DRIVE_IQ_ADVENTURE_CONFIG||{};
var config={
  build:"V606_COFFEE_DEFAULT_STAGED",
  schemaVersion:1,
  app:{
    name:"Drive IQ",modeName:"Adventure Mode",
    homeURL:stringValue(runtime.homeURL||window.DRIVE_IQ_HOME_URL,"https://driveiqgps.com"),
    driveModeURL:stringValue(runtime.driveModeURL||window.DRIVE_IQ_DRIVE_MODE_URL,"/pages/drive-mode"),
    adventureModeURL:stringValue(runtime.adventureModeURL||window.DRIVE_IQ_ADVENTURE_MODE_URL||window.DRIVE_IQ_ADVENTURE_URL,"/pages/adventure-mode")
  },
  api:{
    mapboxToken:stringValue(runtime.mapboxToken||window.DRIVE_IQ_MAPBOX_TOKEN,""),
    geoapifyKey:stringValue(runtime.geoapifyKey||window.DRIVE_IQ_GEOAPIFY_KEY,""),
    googlePlacesKey:stringValue(runtime.googlePlacesKey||window.DRIVE_IQ_GOOGLE_PLACES_KEY||window.DRIVE_IQ_GOOGLE_KEY||window.DIQ_GOOGLE_KEY,""),
    photoResolverURL:stringValue(runtime.photoResolverURL||window.DRIVE_IQ_PHOTO_RESOLVER_URL,"")
  },
  storage:{
    lastFix:"diq_last_gps_v1",
    destination:"diq_dest_v1",
    committedAdventureDestination:"diq_adventure_committed_destination_v1",
    routeGeometry:"diq_route_geo_v1",
    routeIntel:"diq_route_intel_v1",
    drivePayload:"diq_drive_payload_v1",
    driveOn:"diq_drive_on_v1",
    activeDriveID:"diq_active_drive_id_v1",
    activeLens:"diq_adventure_lens_v1",
    favoriteStops:"diq_place_iq_favorite_stops_v1",
    discoveryDrops:"diq_place_iq_drops_v1",
    adventureHistory:"diq_adventure_iq_history_v1",
    adventureDrops:"diq_adventure_drops_v1",
    adventureTaste:"diq_adventure_taste_v1",
    lastScan:"diq_adventure_last_scan_v1",
    photoCache:"diq_place_photo_cache_v1",
    selectedPlace:"diq_adventure_selected_place_v1",
    resumeSnapshot:"diq_adventure_resume_snapshot_v1"
  },
  map:{
    containerID:stringValue(runtime.mapContainerID,"adventureMap"),
    styleURL:stringValue(runtime.mapStyleURL||window.DRIVE_IQ_MAPBOX_STYLE_URL,"mapbox://styles/mapbox/navigation-night-v1"),
    fallbackCenter:{lat:numberValue(runtime.fallbackLatitude,34.98898,-90,90),lng:numberValue(runtime.fallbackLongitude,-90.01259,-180,180)},
    initialZoom:numberValue(runtime.initialZoom,11.5,1,22),
    resultZoom:numberValue(runtime.resultZoom,13.2,1,22),
    placeZoom:numberValue(runtime.placeZoom,15.2,1,22),
    minZoom:numberValue(runtime.minZoom,2,0,22),
    maxZoom:numberValue(runtime.maxZoom,20,1,24),
    defaultBearing:numberValue(runtime.defaultBearing,0,0,360),
    defaultPitch:numberValue(runtime.defaultPitch,0,0,85),
    fitPadding:{
      top:numberValue(runtime.fitPaddingTop,150,0,600),
      right:numberValue(runtime.fitPaddingRight,70,0,600),
      bottom:numberValue(runtime.fitPaddingBottom,245,0,800),
      left:numberValue(runtime.fitPaddingLeft,70,0,600)
    },
    interaction:{
      dragPan:booleanValue(runtime.dragPan,true),
      scrollZoom:booleanValue(runtime.scrollZoom,true),
      touchZoomRotate:booleanValue(runtime.touchZoomRotate,true),
      touchPitch:booleanValue(runtime.touchPitch,false),
      doubleClickZoom:booleanValue(runtime.doubleClickZoom,true),
      boxZoom:booleanValue(runtime.boxZoom,false),
      keyboard:booleanValue(runtime.keyboard,false)
    }
  },
  scan:{
    defaultCategory:stringValue(runtime.defaultCategory,"coffee"),
    defaultScope:stringValue(runtime.defaultScope,"near_me"),
    defaultRadiusMeters:numberValue(runtime.defaultRadiusMeters,12000,500,200000),
    widerRadiusMeters:numberValue(runtime.widerRadiusMeters,32000,1000,300000),
    maximumRadiusMeters:numberValue(runtime.maximumRadiusMeters,80000,1000,500000),
    requestTimeoutMs:numberValue(runtime.requestTimeoutMs,30000,5000,90000),
    fallbackDelayMs:numberValue(runtime.fallbackDelayMs,350,0,5000),
    maximumResults:numberValue(runtime.maximumResults,24,1,60),
    minimumVisibleResults:numberValue(runtime.minimumVisibleResults,5,1,24),
    smallMarketVisibleResults:numberValue(runtime.smallMarketVisibleResults,10,5,24),
    destinationMarketVisibleResults:numberValue(runtime.destinationMarketVisibleResults,18,5,36),
    majorMarketVisibleResults:numberValue(runtime.majorMarketVisibleResults,24,5,36)
  },
  search:{
    minimumQueryLength:numberValue(runtime.minimumQueryLength,2,1,10),
    debounceMs:numberValue(runtime.searchDebounceMs,180,0,2000),
    maximumResults:numberValue(runtime.searchMaximumResults,8,1,20),
    countryCode:stringValue(runtime.countryCode,"us")
  },
  placeCard:{
    cardID:stringValue(runtime.placeCardID,"diqAdventureInfoCard"),
    routeButtonID:stringValue(runtime.routeButtonID,"diqAdvInfoRoute"),
    closeButtonID:stringValue(runtime.closeButtonID,"diqAdvInfoClose"),
    duplicateTapWindowMs:numberValue(runtime.duplicateTapWindowMs,650,100,3000)
  },
  route:{
    requireExactCoordinates:booleanValue(runtime.requireExactCoordinates,true),
    destinationCommitTTLms:numberValue(runtime.destinationCommitTTLms,300000,10000,3600000),
    launchDelayMs:numberValue(runtime.routeLaunchDelayMs,60,0,2000)
  },
  resume:{
    enabled:booleanValue(runtime.resumeEnabled,true),
    snapshotMaximumAgeMs:numberValue(runtime.snapshotMaximumAgeMs,1800000,10000,86400000),
    repaintDelayMs:numberValue(runtime.repaintDelayMs,120,0,2000),
    secondaryRepaintDelayMs:numberValue(runtime.secondaryRepaintDelayMs,420,0,5000)
  },
  logging:{
    enabled:booleanValue(runtime.loggingEnabled,true),
    verbose:booleanValue(runtime.verboseLogging,false),
    prefix:"[Drive IQ Adventure V600]"
  },
  features:{
    mapFirst:true,legacyResultsShelf:false,routeFromPlaceCardOnly:true,
    preserveSelectedPlaceOnResume:true,restoreMapBeforeUI:true,districtIQ:true,
    photoIQ:true,tasteIQ:true,debugOverlay:booleanValue(runtime.debugOverlay,false)
  }
};
if(Object.freeze){
  Object.freeze(config.app);Object.freeze(config.api);Object.freeze(config.storage);
  Object.freeze(config.map.fallbackCenter);Object.freeze(config.map.fitPadding);
  Object.freeze(config.map.interaction);Object.freeze(config.map);
  Object.freeze(config.scan);Object.freeze(config.search);Object.freeze(config.placeCard);
  Object.freeze(config.route);Object.freeze(config.resume);Object.freeze(config.logging);
  Object.freeze(config.features);Object.freeze(config);
}
window.DriveIQAdventureConfig=config;
if(config.logging.enabled&&window.console&&window.console.log){
  window.console.log(config.logging.prefix,"Config loaded",config.build,{
    scanTimeoutMs:config.scan.requestTimeoutMs,
    fallbackDelayMs:config.scan.fallbackDelayMs,
    maximumResults:config.scan.maximumResults,
    minimumVisibleResults:config.scan.minimumVisibleResults,
    smallMarketInventoryTarget:config.scan.smallMarketVisibleResults,
    destinationMarketInventoryTarget:config.scan.destinationMarketVisibleResults,
    majorMarketInventoryTarget:config.scan.majorMarketVisibleResults
  });
}
})(window);
